import React from 'react';
import styled from '@emotion/styled';

import respond from '../../styles/mediaQueries';

const StyledCaseStudy = styled('section')`
    margin-bottom: 20rem;
    & article {
        display: flex;
        justify-content: flex-start;
    }

    & figure {
        display: flex;
        justify-content: center;
    }
    
    ${respond('bp4')} {
         margin-bottom: 12rem;

    }

`;

const StyledCaseStudyReversed = styled(StyledCaseStudy)`
    & article {
        justify-content: flex-end;
    }

`;

const CaseStudySection = ({ children, reverse }) => {
	if (reverse) {
		return <StyledCaseStudyReversed>{children}</StyledCaseStudyReversed>;
	}

	return <StyledCaseStudy>{children}</StyledCaseStudy>;
};

export default CaseStudySection;
